import upSVG from '../../assets/icons/up.svg';
import { CoreIcon, type IconProps } from '../core-icon';

export const UpIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={upSVG} {...props} />;
};
